/** Dark ink on gold — primary-1000 flips to cream in dark, which fails on gold fills. */
const onGoldText = "light-dark(var(--primary-1000), var(--primary-100-light))";

export const headerGoldLine = {
  position: "absolute" as const,
  top: 0,
  left: 0,
  right: 0,
  height: "1px",
  background:
    "linear-gradient(90deg, transparent, var(--neutral-300) 25%, var(--neutral-500) 50%, var(--neutral-300) 75%, transparent)",
  pointerEvents: "none" as const,
};

export const headerGoldFoil = {
  color: "var(--text)",
  WebkitTextFillColor: "unset",
  background: "none",
};

export const accountMenuPaperSx = {
  mt: 1,
  borderRadius: "16px",
  overflow: "hidden",
  border: "none",
  bgcolor: "var(--page-bg)",
  color: "var(--text)",
  backgroundImage: "none",
  boxShadow: "var(--shadow-lg)",
};

export const headerIconButtonSx = {
  borderRadius: "10px",
  padding: { xs: 0.75, sm: 1 },
  color: "var(--text)",
  border: "none",
  transition: "all 0.2s ease",
  "&:hover": {
    bgcolor: "var(--neutral-50)",
    color: "var(--text)",
  },
  "& .MuiSvgIcon-root": {
    fontSize: { xs: 18, sm: 20 },
  },
};

export const headerJoinButtonSx = {
  background: "var(--button-gradient)",
  color: onGoldText,
  fontWeight: 700,
  fontFamily: "var(--primary-font-family)",
  textTransform: "none" as const,
  borderRadius: "10px",
  px: 2,
  py: 0.75,
  fontSize: "0.8125rem",
  boxShadow: "var(--shadow-sm)",
  "&:hover": {
    background: "var(--button-gradient-hover)",
    boxShadow: "var(--shadow-md)",
  },
};

export const headerSearchSx = {
  position: "relative" as const,
  flex: 1,
  maxWidth: 420,
  mx: { xs: 1, md: 4 },
  backgroundColor: "var(--primary-100)",
  borderRadius: "12px",
  display: "flex",
  alignItems: "center",
  px: 2,
  height: 44,
  border: "1px solid var(--primary-200)",
  transition: "border-color 0.2s ease, box-shadow 0.2s ease",
  "&:focus-within": {
    borderColor: "var(--primary-500)",
    boxShadow: "var(--shadow-button-focus)",
  },
};

export const headerLangButtonSx = {
  minWidth: "auto",
  width: "auto",
  fontFamily: "var(--primary-font-family)",
  fontWeight: 600,
  textTransform: "none" as const,
  border: "none",
  bgcolor: "transparent",
  color: "var(--text)",
  transition: "all 0.2s ease",
  "&:hover": {
    bgcolor: "var(--neutral-50)",
    color: "var(--text)",
  },
};

export const taasSwitchSx = {
  width: 42,
  height: 22,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    left: 2,
    top: "50%",
    transform: "translateY(-50%)",
    color: "var(--neutralWhite)",
    "&.Mui-checked": {
      transform: "translateX(calc(42px - 18px - 4px)) translateY(-50%)",
      color: "var(--neutralWhite)",
      "& + .MuiSwitch-track": {
        background: "var(--text)",
        opacity: 1,
      },
    },
  },
  "& .MuiSwitch-thumb": {
    width: 18,
    height: 18,
    boxShadow: "var(--shadow-xs)",
    bgcolor: "var(--page-bg)",
  },
  "& .MuiSwitch-track": {
    borderRadius: 11,
    bgcolor: "var(--neutral-300)",
    opacity: 1,
  },
};

export const menuSectionLabelSx = {
  fontFamily: "var(--primary-font-family)",
  fontSize: "0.68rem",
  fontWeight: 600,
  letterSpacing: "0.08em",
  textTransform: "uppercase" as const,
  color: "var(--text-muted)",
  mb: 1,
};

export const menuAccountCardSx = (active: boolean) => ({
  display: "flex",
  alignItems: "center",
  gap: 1.5,
  px: 1.75,
  py: 1.5,
  borderRadius: "12px",
  cursor: "pointer",
  WebkitTapHighlightColor: "transparent",
  border: "none",
  bgcolor: active ? "light-dark(#f4f4f4, #1a1a1a)" : "transparent",
  boxShadow: "none",
  transition: "background-color 0.2s ease",
  "&:hover": {
    bgcolor: "light-dark(#f7f7f7, #141414)",
  },
});

export const menuGoldBadgeSx = {
  fontFamily: "var(--primary-font-family)",
  fontSize: "0.62rem",
  fontWeight: 600,
  letterSpacing: "0.06em",
  textTransform: "uppercase" as const,
  px: 0.85,
  py: 0.2,
  borderRadius: "999px",
  bgcolor: "light-dark(#f4f4f4, #1a1a1a)",
  color: "var(--text-muted)",
  border: "none",
};

export const menuActiveBadgeSx = {
  fontFamily: "var(--primary-font-family)",
  fontSize: "0.62rem",
  fontWeight: 600,
  letterSpacing: "0.06em",
  textTransform: "uppercase" as const,
  height: "auto",
  px: 0.85,
  py: 0.2,
  borderRadius: "999px",
  bgcolor: "var(--text)",
  color: "var(--page-bg)",
  "& .MuiChip-label": {
    px: 0,
    color: "inherit",
  },
};

export const menuOutlineButtonSx = {
  fontFamily: "var(--primary-font-family)",
  textTransform: "none" as const,
  fontWeight: 600,
  fontSize: "0.8125rem",
  borderRadius: "10px",
  border: "none",
  color: "var(--text)",
  "&:hover": {
    bgcolor: "light-dark(#f4f4f4, #1a1a1a)",
  },
};

export const menuPrimaryButtonSx = {
  background: "var(--button-gradient)",
  color: onGoldText,
  fontWeight: 700,
  fontFamily: "var(--primary-font-family)",
  textTransform: "none" as const,
  borderRadius: "10px",
  fontSize: "0.8125rem",
  minHeight: 40,
  boxShadow: "var(--shadow-sm)",
  "&:hover": {
    background: "var(--button-gradient-hover)",
    boxShadow: "var(--shadow-md)",
  },
};

export const menuPrimaryOutlineSx = {
  ...menuOutlineButtonSx,
  border: "none",
};
